import { Box } from "@mui/material";
import { CSSProperties } from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number | string;
  value: number | string;
  style?: CSSProperties;
}

export const KeyDriveTabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
        style={props.style}
      >
        {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
      </div>
    );
}